<script lang="ts">
  import type { PageData } from './$types';
  import Auctions from '../../Auctions.svelte';

  export let data: PageData;

  $: liveBidsEnabled = data.status !== 'closed';
</script>

{#key data.status}
  <Auctions {liveBidsEnabled} auctions={data.auctions} nextPage={data.hasNextPage} categories={data.categories} />
{/key}
